import { Store } from '../../../../Store';
import React, {
  useEffect,
  useReducer,
  useContext,
  useState,
  useCallback,
  useRef,
} from 'react';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getError } from '../../../../utils';
import axios from 'axios';

import EmojiPicker from 'emoji-picker-react';

import { getReducer } from '../../../../utils';
import ModalLogin from '../../login/ModalLogin';
import LoadingBox from '../../../compoment/LoadingBox';
import MessageBox from '../../../compoment/MessageBox';

import '../css/comments.css';
import ModalRemove from '../../../compoment/ModalRemove';
import ReplyForm from './ReplyForm';
import ImagesAvatar from './ImagesAvatar';
import CommentItem from './CommentItem';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS_COMMENTS':
      return { ...state, comments: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    case 'CREATE_REQUEST':
      return { ...state, loadingCreate: true };
    case 'CREATE_SUCCESS':
      return {
        ...state,
        loading: false,
        comments: [action.payload, ...state.comments],
      };
    case 'CREATE_FAIL':
      return { ...state, loadingCreate: false };
    case 'DELETE_REQUEST':
      return { ...state, loadingDelete: true, successDelete: false };
    case 'DELETE_SUCCESS':
      return {
        ...state,
        loadingDelete: false,
        successDelete: true,
      };
    case 'DELETE_FAIL':
      return { ...state, loadingDelete: false, successDelete: false };

    case 'DELETE_RESET':
      return { ...state, loadingDelete: false, successDelete: false };
    default:
      return state;
  }
};

const Comments = ({ ableId }) => {
  const MIN_MESSAGE_LENGTH = 10;
  const MAX_REPLY_LENGTH = 5;

  const [{ loading, error, comments }, dispatch] = useReducer(
    getReducer(reducer),
    {
      comments: [],
      loading: true,
      error: '',
    }
  );

  const [modalShow, setModalShow] = useState(false);
  const [hiddenReplies, setHiddenReplies] = useState(null);
  const [sliceReplies, setSliceReplies] = useState(0);

  const [replyUser, setReplyUser] = useState('');
  const [removeId, setRemoveId] = useState(null);
  const [removeShow, setRemoveShow] = useState(false);

  const [minMessage, setMinMessage] = useState(false);
  const [minMessageReply, setMinMessageReply] = useState(false);

  const [content, setContent] = useState('');
  const [formData, setFormData] = useState({
    ableId,
    content: '',
    replyTo: null,
    parentId: null,
  });

  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const { state } = useContext(Store);
  const { userInfo } = state;

  const formRef = useRef();
  const editorRef = useRef(null);
  const textareaRef = useRef(null);
  const parentCommentRef = useRef(null);

  const fetchData = useCallback(async () => {
    if (!ableId) return;
    dispatch({ type: 'FETCH_REQUEST' });
    try {
      const { data } = await axios.get(
        `/comment/post/public/shows?ableId=${ableId}`
      );
      dispatch({
        type: 'FETCH_SUCCESS_COMMENTS',

        payload: data.data,
      });
    } catch (err) {
      dispatch({ type: 'FETCH_FAIL', payload: err.message });
    }
  }, [ableId, dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleCancel = () => {
    setMinMessage(false);
    setFormData({
      ableId,
      content: '',
      replyTo: null,
      parentId: null,
    });
    setContent('');

    if (editorRef.current) {
      editorRef.current.innerHTML = '';
    }
  };

  const handleSubmit = async (e, status) => {
    e.preventDefault();

    let submitData = { ...formData };

    if (status) {
      if (content && content.length <= MIN_MESSAGE_LENGTH) {
        setMinMessage(true);
        return;
      }

      submitData = { ...formData, content, replyTo: null, parentId: null };
    } else {
      if (
        submitData.content &&
        submitData.content.length <= MIN_MESSAGE_LENGTH
      ) {
        setMinMessageReply(true);
        return;
      }
    }

    try {
      dispatch({ type: 'CREATE_REQUEST' });
      const result = await axios.post('/comment/post/create', submitData, {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      });
      toast.success(result.data.message);
      dispatch({ type: 'CREATE_SUCCESS' });
      await fetchData();
      handleCancel();
    } catch (err) {
      toast.error(getError(err) || 'Đã xảy ra lỗi!');
      dispatch({
        type: 'CREATE_FAIL',
      });
    }
  };

  // const handleReply = (idCmt, idUser, fullName) => {
  //   setTimeout(() => {
  //     if (editorRef.current) {
  //       const editor = editorRef.current;
  //       const text = `${fullName} `;

  //       editor.innerHTML = `<strong className='reply-name'>${text}</strong>&nbsp;`;
  //       setContent(editor.innerHTML.trim());
  //       setReplyInvalid(idCmt);

  //       setReplyTo(idUser);
  //       setParentId(idCmt);
  //       setReplyUser(fullName);

  //       const range = document.createRange();
  //       const sel = window.getSelection();
  //       range.selectNodeContents(editor);
  //       range.collapse(false);
  //       sel.removeAllRanges();
  //       sel.addRange(range);

  //       editor.focus();
  //     }
  //   }, 300);
  // };

  const handleConfirmRemove = async () => {
    try {
      dispatch({ type: 'DELETE_REQUEST' });
      const result = await axios.delete(`/comment/user/destroy/${removeId}`, {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      });
      toast.success(result.data.message);
      dispatch({ type: 'DELETE_SUCCESS' });
      await fetchData();
      setRemoveShow(false);
      setRemoveId(null);
    } catch (err) {
      toast.error(getError(err) || 'Đã xảy ra lỗi!');
      dispatch({ type: 'DELETE_FAIL' });
      setRemoveShow(false);
    }
  };

  const handleInputComment = (e) => {
    setContent(e.target.value);

    const el = textareaRef.current;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  };

  const handleEmojiClick = (emojiData) => {
    setContent(content + emojiData.emoji);
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleShowReplies = (id) => {
    setHiddenReplies(id);
    if (hiddenReplies === id) {
      setSliceReplies(sliceReplies + MAX_REPLY_LENGTH);
    } else {
      setSliceReplies(MAX_REPLY_LENGTH);
    }
  };

  const handleHideReplies = () => {
    setSliceReplies(0);
    setHiddenReplies(0);
  };

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger"> {error} </MessageBox>
  ) : (
    <section className="comments mt-lg-5">
      <h3 className="mb-3">Bình luận</h3>

      {comments.map((comment) => (
        <div key={comment.id} className="item-comment d-flex ">
          <ImagesAvatar user={comment.user} />

          <div className="w-100 mb-2">
            <CommentItem
              editorRef={editorRef}
              ableId={ableId}
              item={comment}
              userInfo={userInfo}
              setRemoveId={setRemoveId}
              setRemoveShow={setRemoveShow}
              setReplyUser={setReplyUser}
              setMinMessageReply={setMinMessageReply}
              formData={formData}
              setFormData={setFormData}
            />

            {comment.replies && comment.replies.length > 0 && (
              <div className=" replies">
                <div
                  ref={parentCommentRef}
                  className={`list-reply ${
                    hiddenReplies === comment.id ? 'visible' : 'hidden'
                  }`}
                >
                  {comment.replies.slice(0, sliceReplies).map((reply) => (
                    <div key={reply.id} className="d-flex reply">
                      <ImagesAvatar user={reply.user} />
                      <div className="w-100 mb-2">
                        <CommentItem
                          editorRef={editorRef}
                          ableId={ableId}
                          item={reply}
                          userInfo={userInfo}
                          setRemoveId={setRemoveId}
                          setRemoveShow={setRemoveShow}
                          setReplyUser={setReplyUser}
                          setMinMessageReply={setMinMessageReply}
                          formData={formData}
                          setFormData={setFormData}
                        />

                        <ReplyForm
                          MIN_MESSAGE_LENGTH={MIN_MESSAGE_LENGTH}
                          userInfo={userInfo}
                          setFormData={setFormData}
                          handleSubmit={(e) => handleSubmit(e, false)}
                          replyUser={replyUser}
                          formData={formData}
                          minMessageReply={minMessageReply}
                          className={
                            formData.parentId === reply.id ? 'visible' : ''
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>

                {hiddenReplies === comment.id ? (
                  comment.replies.length > sliceReplies ? (
                    <h5
                      className="hidden-replies"
                      onClick={() =>
                        setSliceReplies((prev) => prev + MAX_REPLY_LENGTH)
                      }
                    >
                      Xem thêm phản hồi ...
                    </h5>
                  ) : (
                    <h5 className="hidden-replies" onClick={handleHideReplies}>
                      [ Ẩn ]
                    </h5>
                  )
                ) : (
                  <h5
                    className="hidden-replies"
                    onClick={() => handleShowReplies(comment.id)}
                  >
                    Xem tất cả {comment.replies.length} phản hồi ...
                  </h5>
                )}
              </div>
            )}

            <ReplyForm
              MIN_MESSAGE_LENGTH={MIN_MESSAGE_LENGTH}
              userInfo={userInfo}
              setFormData={setFormData}
              handleSubmit={(e) => handleSubmit(e, false)}
              replyUser={replyUser}
              formData={formData}
              minMessageReply={minMessageReply}
              className={formData.parentId === comment.id ? 'visible' : ''}
            />
          </div>
        </div>
      ))}

      {userInfo ? (
        <form
          ref={formRef}
          onSubmit={(e) => handleSubmit(e, true)}
          className="form-comment shadow-lg"
        >
          <h4>Nội dung</h4>
          {/*replyUser && (
            <p className="reply-to-user">
              Đang phản hồi <strong>{replyUser}</strong> &#8226;{' '}
              <span onClick={handleCancel}>
                <i className="fas fa-times"></i> Hủy
              </span>
            </p>
          )*/}

          <div
            style={{
              position: 'relative',
              width: '100%',
              border: '1px solid #ccc',
              borderRadius: '8px',
              outline: 'none',
            }}
          >
            <textarea
              className="editor"
              ref={textareaRef}
              placeholder="Nhập vào nội dung bình luận của bạn..."
              value={content}
              onChange={handleInputComment}
              style={{
                width: '100%',
                border: 'none',
                padding: '0.5rem 0.5rem 0',
                outline: 'none',
                boxShadow: 'none',
                resize: 'none',
                borderRadius: '8px',
              }}
            ></textarea>

            <div className="d-flex mx-1 mb-1">
              <button
                type="button"
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '24px',
                  marginLeft: '0.5rem',
                  color: 'var(--dark-gray)',
                }}
              >
                <i className="far fa-smile w-100"></i>
              </button>
              {showEmojiPicker && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '40px',
                    left: '1rem',
                    zIndex: 100,
                  }}
                >
                  <EmojiPicker onEmojiClick={handleEmojiClick} />
                </div>
              )}
              <button type="submit" className="btn-send ms-auto">
                <img
                  src="/images/icons/send.png"
                  alt=""
                  className="icon-send "
                />
              </button>
            </div>
          </div>

          {minMessage && (
            <p className="text-danger message-text mt-2">
              Nội dung phải có ít nhất {MIN_MESSAGE_LENGTH} ký tự!
            </p>
          )}
        </form>
      ) : (
        <div className="comments">
          <p>
            Nếu muốn bình luận cho bài viết này, bạn cần{' '}
            <span className="cmt-login" onClick={() => setModalShow(true)}>
              Đăng nhập
            </span>{' '}
            !
          </p>
          <ModalLogin show={modalShow} onHide={() => setModalShow(false)} />
        </div>
      )}

      <ModalRemove
        show={removeShow}
        onHide={() => setRemoveShow(false)}
        onConfirm={handleConfirmRemove}
      />
    </section>
  );
};

export default Comments;
